import { observer } from "mobx-react-lite";
import { NavLink, useNavigate } from "react-router-dom";
import { Button, Dropdown } from "antd";
import { EasyAvatar } from "fin-web-components";
import { globalModel } from "../../global/GlobalModel";
import { siteConfig } from "../../site-config/SiteConfig";
import { avatarDisplayWord } from "../../utils/avatarDisplayWord";
import { resolveAppMediaUrl } from "../../utils/resolveAppMediaUrl";
import { siteNavUserAvatarCssVars, siteNavUserAvatarSize } from "../../SiteConfig";
import { STANDALONE_PRODUCT_SLOTS } from "./standaloneProductSlots";
import { standaloneTactikUserMenu } from "./standaloneTactikUserMenu";
import "./TactikSiteTopBar.css";

type Props = {
  variant?: "default" | "hero";
  heroScrolled?: boolean;
};

export const TactikSiteTopBar = observer((props: Props) => {
  const { variant = "default", heroScrolled = false } = props;
  const navigate = useNavigate();
  const userMenu = standaloneTactikUserMenu({ navigate });

  const rootClass = [
    "tactik-site-top",
    variant === "hero" && "tactik-site-top--hero",
    variant === "hero" && heroScrolled && "tactik-site-top--hero-scrolled",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <header className={rootClass} style={siteNavUserAvatarCssVars()}>
      <div className="tactik-site-top-inner">
        <div
          className="tactik-site-brand"
          onClick={() => navigate("/")}
          role="presentation"
        >
          <img
            className="tactik-site-brand-img"
            src={siteConfig.shellLogo}
            alt={siteConfig.shellLogoAlt}
            draggable={false}
          />
          <span className="tactik-site-brand-name">
            {siteConfig.shellBrandNavLabel}
          </span>
        </div>
        <nav className="tactik-site-nav" aria-label="站点导航">
          <div className="tactik-site-nav-links">
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                isActive
                  ? "tactik-site-nav-link tactik-site-nav-link--active"
                  : "tactik-site-nav-link"
              }
            >
              首页
            </NavLink>
            {STANDALONE_PRODUCT_SLOTS.map((slot) => (
              <NavLink
                key={slot.slotKey}
                to={`/tactik/${slot.routePath}`}
                className={({ isActive }) =>
                  isActive
                    ? "tactik-site-nav-link tactik-site-nav-link--active"
                    : "tactik-site-nav-link"
                }
              >
                {slot.label}
              </NavLink>
            ))}
            {globalModel.isLoggedIn ? (
              <NavLink
                to="/tactik/my-notes"
                className={({ isActive }) =>
                  isActive
                    ? "tactik-site-nav-link tactik-site-nav-link--active"
                    : "tactik-site-nav-link"
                }
              >
                我的笔记
              </NavLink>
            ) : null}
          </div>
        </nav>
        <div className="tactik-site-top-right">
          {globalModel.isLoggedIn ? (
            <Dropdown
              menu={userMenu}
              trigger={["click"]}
              getPopupContainer={() => document.body}
              overlayStyle={{ zIndex: 2000 }}
            >
              <div className="tactik-site-user">
                <EasyAvatar
                  shape="circle"
                  size={siteNavUserAvatarSize}
                  url={resolveAppMediaUrl(globalModel.currentUser?.avatarUrl)}
                  word={avatarDisplayWord(globalModel.currentUser?.name ?? "")}
                  alt=""
                />
                <span className="tactik-site-user-name">
                  {globalModel.currentUser?.name ?? "用户"}
                </span>
              </div>
            </Dropdown>
          ) : (
            <Button
              type="text"
              className="tactik-site-login"
              onClick={() => globalModel.openLoginModal()}
            >
              登录/注册
            </Button>
          )}
        </div>
      </div>
    </header>
  );
});
